/* eslint-disable no-nested-ternary */
import { WaveVariantB } from '@tmov/design-system/icons';
import React, { useEffect, useState } from 'react';

import { LoadingContainer } from '../../../components/LoadingContainer';
import NoDataContainer from '../../../components/NoDataContainer';
import { clientesPagadores } from '../../../helpers/clientesPagadores';
import { useAuth } from '../../../security/authContext';
import Filters from './Filters';
import useFilters from './hooks/useFilters';
import Stats from './Stats';
import { Container } from './styles';
import TimeGraph from './TimeGraph';

function Geral() {
  const { user } = useAuth();
  const filters = useFilters();

  const [clientes, setClientes] = useState(null);
  const [loadingClientes, setLoadingClientes] = useState(false);

  useEffect(() => {
    const getClientes = async () => {
      setLoadingClientes(true);
      const result = await clientesPagadores(user.clientes_pagadores);
      setClientes(result.map(cliente => cliente.cnpj));
      setLoadingClientes(false);
    };
    getClientes();
  }, [user.clientes_pagadores]);

  return (
    <Container>
      {clientes ? (
        <>
          <Filters filters={filters} />
          <Stats clientes={clientes} filters={filters} />
          <TimeGraph clientes={clientes} filters={filters} />
        </>
      ) : loadingClientes ? (
        <LoadingContainer>
          <WaveVariantB size="60px" />
        </LoadingContainer>
      ) : (
        <NoDataContainer
          title="Não foi possível obter os dados para o Dashboard"
          description="Por favor tente novamente ou entre em contato com o suporte"
        />
      )}
    </Container>
  );
}

export default Geral;
